import {
  http,
  indusWinHttp,
  sportsHttp,
  fantasyCenterHttp,
  pick11Http,
} from '@utils';
import {
  ScratchListItem,
  NoticeCheckList,
  BannerListItem,
  HotGameItem,
  KeralaListItem,
  DigitListItem,
  DiceListItem,
  MatkaListItem,
  LiveHotGameItem,
  LiveGameItem,
  LiveGameListParams,
  ColorListItem,
  HomeGameParams,
  HomeGameFloorItem,
  HomeGoldGame,
  SportItem,
} from './home.type';
import globalStore from '@/services/global.state';
import {SafeAny} from '@/types';

/** 获取刮刮乐入口列表 */
export const getScratchList = () => {
  return indusWinHttp.get<null, ScratchListItem[]>(
    'iGaming/api/scratchoffGameList',
  );
};

/** 获取活动入口 */
export const getNoticeCheck = () => {
  return http.post<null, NoticeCheckList>('app/sys/notice/check');
};

/** 顶部banner */
export const getBannerList = (type = 2) => {
  return http.post<{type: number}, BannerListItem[]>(
    'app/banner/manage/display/list',
    {
      type,
    },
  );
};

/** 热门小游戏 */
export const getHotGameList = () => {
  return http.post<null, HotGameItem[]>('app/hotGame/list');
};

/** kerala列表 */
export const getKeralaList = () => {
  return http.post<{type: number}, KeralaListItem[]>(
    'app/lottery/type/kerala/list/new',
    {type: 1},
  );
};

/** 3Digit列表 */
export const getDigitList = () => {
  return http.post<null, DigitListItem[]>('app/pick/info/list');
};

/** Dice列表 */
export const getDiceList = () => {
  return http.post<null, DiceListItem[]>('app/diceThree/homeList');
};
/** color列表 */
export const getColorList = () => {
  return http.post<null, ColorListItem[]>('app/redGreen/config/getAll');
};

/** Matka列表 */
export const getMatkaList = () => {
  return http.post<null, MatkaListItem[]>('app/matka/lottery/home/list');
};

export const getLiveHotGameList = () => {
  return indusWinHttp.get<null, LiveHotGameItem[]>('iGaming/liveHotGameList');
};

/**
 * 首页视讯游戏列表
 * @param gameName 游戏名称（筛选）
 * @param sort 可不传 0 desc 1 asc
 */
export function getLiveGameList(gameName?: string, sort?: number) {
  return indusWinHttp.get<LiveGameListParams, LiveGameItem[]>(
    'iGaming/liveGameList',
    {
      params: {
        gameName,
        sort,
      },
    },
  );
}

export function getNotices() {
  return http.post<null, string[]>('app/h5/getNotices');
}

export const getSprotUrl = () => {
  return http.get<null, string>('sport/sap/start');
};

/** Home金刚去游戏列表 */
export const getHomeGoldGames = () => {
  return http.post<{groupCode: 'KING_KONG'}, HomeGoldGame[]>(
    'app/moduleTypes/getAllListBySort',
    {
      groupCode: 'KING_KONG',
    },
  );
};

export const getSideList = () => {
  return http.post<{groupCode: 'SUSPENSION_APP'}, HomeGoldGame[]>(
    'app/moduleTypes/getAllListBySort',
    {
      groupCode: 'SUSPENSION_APP',
    },
  );
};

/** Home游戏板块列表 */
export const getHomeGames = () => {
  return http.post<HomeGameParams, HomeGameFloorItem[]>(
    'app/homeGamesCategory/getAllListBySortV4',
    {
      position: 8,
    },
  );
};

export const getSportGames = () => {
  return http.post<{groupCode: string}, SportItem[]>(
    'app/moduleTypes/getAllListBySort',
    {
      groupCode: 'SPORT_GAME',
    },
  );
};

export const getGameURL = (gameType: string) => {
  return indusWinHttp.get<string, string>(
    `sport/sportGame/getGameUrl?gameType=${gameType}`,
  );
};

/** 获取 Pick11 游戏 URL token */
export const getPick11GameUrl = () => {
  return pick11Http.get<null, string | {token?: string}>(
    'sport/sportGame/getGameUrl?gameType=fantasy',
  );
};

export const getBetBy = () => {
  return indusWinHttp.get<null, {brandId: string; token: string}>(
    `sport/betby/getToken?lang=${
      globalStore.lang ? globalStore.lang.split('_')[0] : 'en'
    }`,
  );
};
type TriggerDownloadRewardProps = {
  trigger_type: 1 | 2; // 1 下载触发 2 提现充值触发
};
// 触发领取app奖励 默认下载触发
export const triggerDownloadReward = (data: TriggerDownloadRewardProps) => {
  const {trigger_type} = data || {};
  return http.post('app/download/triggerReward', {
    trigger_type,
  });
};
// app进行奖励领取 旨在app下中调用
export const claimRewardDownloadReward = () => {
  return http.post<
    any,
    {
      baseAmount: number;
      totalAmount: number;
      vipBonusAmount: number;
      vipBonusRate: number;
      vipLevel: number;
    }
  >('app/download/claimReward');
};
// 判断用户是否有可领取的金额
export const getRewardStatus = () => {
  return http.get<
    any,
    {
      // 是否领取过奖励
      hasClaimed: boolean;
      // 是否有未领取
      hasUnclaimed: boolean;
      // 未领取的奖励金额（如果有）
      unclaimedAmount: number;
    }
  >('app/download/rewardStatus');
};

// 获取h5转app配置 /download/rewardConfig
export const getDownloadRewardConfig = () => {
  return http.get<any, any>('/app/download/rewardConfig');
};

export const getGR8Token = () => {
  return sportsHttp.get<null, SafeAny>('gr8/api/v1/auth/get-jwt-token');
};

/** P11 推荐赛事单场数据 */
export interface P11MatchItem {
  id?: number;
  fantasyMatchId?: number;
  dateStart: number;
  dateEnd: number;
  teamaBgImg?: string;
  teambBgImg?: string;
  teamaBgColor?: string;
  teambBgColor?: string;
  teamaLogoUrl?: string;
  teambLogoUrl?: string;
  teamaShortName?: string;
  teambShortName?: string;
  maxPrizePool?: number;
  fantasyCompetitionTitle?: string;
  teamaName?: string;
  teambName?: string;
  status?: string;
}

/** P11 联赛（含多场赛事） */
export interface P11CompetitionItem {
  fantasyCompetitionId?: number;
  fantasyCompetitionTitle?: string;
  matches?: P11MatchItem[];
}

/** 获取 P11 推荐赛事列表（按 tagName pick11 时调用） */
export const getP11MatchList = () => {
  return fantasyCenterHttp.post<
    Record<string, never>,
    {
      upcomingTotal: number;
      matches: P11CompetitionItem[];
    }
  >('/api/front/p11/match/list-display', {});
};

export type ExchangeAutoCodeResponse = {
  totalAmount?: number | string;
  codes?: Array<{
    codeId: string;
    remark: string;
  }>;
};

export const getExchangeAutoCode = () => {
  return http.post<any, ExchangeAutoCodeResponse | null>(
    '/app/exchange/auto/code',
  );
};
